module.exports = __webpack_public_path__ + "static/media/fsn.807c57ac.svg";